'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _googleMaps = require('google-maps');

var _googleMaps2 = _interopRequireDefault(_googleMaps);

var _styles = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_googleMaps2.default.LIBRARIES = ['places'];

var NitroAddressAutoComplete = function (_Component) {
  _inherits(NitroAddressAutoComplete, _Component);

  function NitroAddressAutoComplete(props) {
    _classCallCheck(this, NitroAddressAutoComplete);

    var _this = _possibleConstructorReturn(this, (NitroAddressAutoComplete.__proto__ || Object.getPrototypeOf(NitroAddressAutoComplete)).call(this, props));

    _this.onGoogleMapsAPILoad = function (google) {
      if (!_this.componentIsMounted) {
        return;
      }

      var options = {
        componentRestrictions: { country: 'au' },
        types: ['address']
      };

      var input = _this.input.getInputNode();

      var geoAutocomplete = new google.maps.places.Autocomplete(input, options);

      geoAutocomplete.addListener('place_changed', function () {
        var selectedPlace = geoAutocomplete.getPlace();
        var componentForm = {
          street_number: 'short_name',
          route: 'long_name',
          locality: 'long_name',
          administrative_area_level_1: 'short_name',
          country: 'long_name',
          postal_code: 'short_name'
        };
        // Get each component of the address from the place details
        // and fill the corresponding field on the form.
        var selectedSuggest = {};
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = selectedPlace.address_components[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var addressComponent = _step.value;

            var addressType = addressComponent.types[0];
            if (componentForm[addressType]) {
              selectedSuggest[addressType] = addressComponent[componentForm[addressType]];
            }
          }

          // input.value = selectedPlace.name // Code injection risk (check doc)
          // input.value = `${selectedSuggest.street_number}, ${selectedSuggest.route}`;
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        var street_number = selectedSuggest.street_number,
            route = selectedSuggest.route,
            locality = selectedSuggest.locality,
            administrative_area_level_1 = selectedSuggest.administrative_area_level_1,
            country = selectedSuggest.country;


        var streetAddress = [street_number, route].join(' ');

        var dropDownAddress = [streetAddress, locality, administrative_area_level_1, country].join(', ').trim();

        var deliveryState = selectedSuggest.administrative_area_level_1;
        var deliveryPostalCode = selectedSuggest.postal_code;
        var deliverySuburb = selectedSuggest.locality;

        _this.setState({
          value: dropDownAddress
        });

        if (typeof _this.props.setDeliveryDetailsAddress === 'function') {
          _this.props.setDeliveryDetailsAddress(dropDownAddress, deliveryState, deliveryPostalCode, deliverySuburb, streetAddress);
        }
      });
    };

    _this.handleChange = function (event, value) {
      if (typeof value !== 'string') {
        return;
      }

      _this.setState({
        value: value
      });

      if (typeof _this.props.onChange === 'function') {
        _this.props.onChange(event, value);
      }
    };

    _this.handleBlur = function (event) {
      if (typeof _this.props.onBlur === 'function') {
        _this.props.onBlur(event);
      }
    };

    _this.handleFocus = function (event) {
      if (typeof _this.props.onFocus === 'function') {
        _this.props.onFocus(event);
      }
    };

    _this.state = {
      value: props.value || ''
    };

    if (props.googleAPIKey) {
      _googleMaps2.default.KEY = props.googleAPIKey;
    }
    return _this;
  }

  _createClass(NitroAddressAutoComplete, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.componentIsMounted = true;
      if (window.google) {
        this.onGoogleMapsAPILoad(window.google);
        return;
      }

      _googleMaps2.default.load(this.onGoogleMapsAPILoad);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.componentIsMounted = false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          disabled = _props.disabled,
          hintText = _props.hintText,
          floatingLabelFixed = _props.floatingLabelFixed,
          floatingLabelText = _props.floatingLabelText,
          fullWidth = _props.fullWidth,
          errorText = _props.errorText;


      return _react2.default.createElement(_styles.StyledInput, {
        className: className,
        disabled: disabled,
        floatingLabelFixed: floatingLabelFixed,
        floatingLabelText: floatingLabelText,
        fullWidth: fullWidth,
        hintText: hintText,
        errorText: errorText,
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        placeholder: '',
        innerRef: function innerRef(elem) {
          _this2.input = elem;
        },
        value: this.state.value,
        height: '48px'
      });
    }
  }]);

  return NitroAddressAutoComplete;
}(_react.Component);

NitroAddressAutoComplete.propTypes = {
  className: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  floatingLabelFixed: _propTypes2.default.bool,
  floatingLabelText: _propTypes2.default.string,
  fullWidth: _propTypes2.default.bool,
  errorText: _propTypes2.default.node,
  googleAPIKey: _propTypes2.default.string,
  hintText: _propTypes2.default.string,
  onBlur: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  setDeliveryDetailsAddress: _propTypes2.default.func,
  value: _propTypes2.default.string
};

NitroAddressAutoComplete.defaultProps = {
  floatingLabelFixed: true,
  floatingLabelText: 'Search address'
};

exports.default = NitroAddressAutoComplete;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-address-auto-complete/NitroAddressAutoComplete.js
// module id = 2879
// module chunks = 4